import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: "",
  withincol:"",
  within:"",
  maincol:""
};

const analyticsslice = createSlice({
  name: "analysticsvisualise",
  initialState,
  reducers: {
    setAnalyticsVisual: (state, action) => {
      state.data =  action.payload.data;
      state.withincol =  action.payload.withincol;
      state.within =  action.payload.within;
      state.maincol =  action.payload.maincol;
    }
  },
});

export const { setAnalyticsVisual } = analyticsslice.actions;

export const selectAnalyticsVis = (state) => state.analysticsvisualise;


export default analyticsslice.reducer;
